import { render, staticRenderFns } from "./loading.vue?vue&type=template&id=07da62e2"
var script = {}
import style0 from "./loading.vue?vue&type=style&index=0&id=07da62e2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports